import { render } from "./GeneralReportsView.vue?vue&type=template&id=6c0cd52a"
import script from "./GeneralReportsView.vue?vue&type=script&lang=js"
export * from "./GeneralReportsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__